import { useEffect } from "react";
import useKlashaScript from "./klasha-script";
import { callKlashaClient } from "./klasha-actions";

export default function useKlashaPayment(options) {
  const [scriptLoaded, scriptError] = useKlashaScript(options.isTestMode);
  const {
    isTestMode,
    merchantKey,
    businessId,
    amount,
    tx_ref,
    sourceCurrency,
    destinationCurrency,
    fullname,
    email,
    phone_number,
    paymentDescription,
    callbackUrl,
    metadata,
    kit,
  } = options;

  function clean(obj) {
    for (const propName in obj) {
      if (obj[propName] === null || obj[propName] === undefined) {
        delete obj[propName];
      }
    }
    return obj;
  }

  function initializePayment(callBack) {
    if (scriptError) {
      throw new Error("Unable to load klasha inline script");
    }

    const klashaArgs = {
      callBack: callBack ? callBack : null,
      isTestMode,
      merchantKey,
      businessId,
      amount,
      tx_ref,
      destinationCurrency: destinationCurrency || "NGN",
      sourceCurrency: sourceCurrency || "NGN",
      fullname: fullname || "",
      email: email || "",
      phone_number: phone_number || "",
      paymentDescription: paymentDescription || "",
      callbackUrl: callbackUrl || "",
      metadata: metadata || {},
      kit: kit || null,
      "data-custom-button": options["data-custom-button"] || "",
    };

    const isReady =
      scriptLoaded || (typeof window !== "undefined" && Boolean(window.KlashaClient));

    if (isReady) {
      callKlashaClient(clean(klashaArgs));
      return;
    }

    if (typeof window !== "undefined") {
      let elapsed = 0;
      const interval = 100;
      const maxWait = 3000;

      const checkTimer = setInterval(() => {
        elapsed += interval;
        if (window.KlashaClient) {
          clearInterval(checkTimer);
          callKlashaClient(clean(klashaArgs));
        } else if (elapsed >= maxWait) {
          clearInterval(checkTimer);
          console.error("Klasha script did not load within timeout");
        }
      }, interval);
    }
  }

  useEffect(() => {
    if (typeof window === "undefined") return;

    const isLocalhostOrDev =
      window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1" ||
      process.env.REACT_APP_ENV === "dev" ||
      process.env.REACT_APP_IS_DEV === "dev";

    if (!isLocalhostOrDev) return;

    const handleLocalhostMessageGuard = (ev) => {
      if (ev.origin === window.location.origin && ev.source === window) {
        if (
          !ev.data?.status &&
          ev.data?.type !== "klasha:stitch" &&
          ev.data?.card !== "redirect"
        ) {
          ev.stopImmediatePropagation();
        }
      }
    };

    window.addEventListener("message", handleLocalhostMessageGuard, true);

    return () => {
      window.removeEventListener(
        "message",
        handleLocalhostMessageGuard,
        true
      );
    };
  }, []);

  useEffect(() => {
    if (scriptError) {
      console.error("Unable to load klasha inline script");
    }
  }, [scriptError]);

  return initializePayment;
}
